import { render, staticRenderFns } from "./ContentSettingsEditor.vue?vue&type=template&id=050f1490"
import script from "./ContentSettingsEditor.vue?vue&type=script&lang=js"
export * from "./ContentSettingsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports